import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import SwalAlert from "../../services/swalService/SwalService";
import { useAddEditAdminDetailsMutation, useLazyGetSignUpDropDownsForCorporateMembersQuery } from "../../app/services/common/commonApi";
import FormCreator from "../../components/Forms/FormCreator";
import Buttons from "../../components/ui/button/Buttons";
import { CreateAccountManagementData } from "./data/CreateAccountManagement.data";
import { setAllDropDownField } from "./utils/dropdownUtils";

const CreateAccountManagement = forwardRef( ( props, ref ) => {
    const createAccountRef = useRef();
    const [ formData, setFormData ] = useState( CreateAccountManagementData );
    const { success,error } = SwalAlert();
    const [ createAccount, { isSuccess: isSuccessUpdate, isLoading: isFetchingAppUpdate, data: createAccountResponse }, ] = useAddEditAdminDetailsMutation();
    const [ getAllDropDowns, { isSuccess: isGetAllDropDownFetched, isLoading: isGetDropDownFetching, data: allDropDownResponse }, ] = useLazyGetSignUpDropDownsForCorporateMembersQuery();

    useEffect( () => {
        if ( !isFetchingAppUpdate && isSuccessUpdate && createAccountResponse ) {
            if(createAccountResponse?.errorMessage == "Email already exist"){
                error("Email Is Already Exist For Same Role")
            }
            else {
                 success( "", "Account Created Successfully! " )
                }
          
            handleClear();
        }
    }, [ isFetchingAppUpdate, isSuccessUpdate, createAccountResponse ] );

    useEffect( () => {
        getAllDropDowns();
    }, [] )

    useEffect( () => {
        if ( !isGetDropDownFetching && isGetAllDropDownFetched && allDropDownResponse ) {
            setAllDropDownField( allDropDownResponse );
        }
    }, [ isGetDropDownFetching, isGetAllDropDownFetched, allDropDownResponse ] );

    useImperativeHandle( ref, () => ( {
        getFormData: () => {
            if ( ref?.current )
            {
                const CreateAccountManagementData =
                    createAccountRef?.current?.getFormData();
                return CreateAccountManagementData;
            }
            return null;
        },
    } ) );

    const handleCreate = () => {
        let accountInformationData = createAccountRef?.current?.getFormData();
        if ( !accountInformationData ) {
            return false
        }

        let request = {
            AdminID: 0,
            Name: accountInformationData?.firstname || null,
            LastName: accountInformationData?.lastName || null,
            Email: accountInformationData?.email || null,
            Password: accountInformationData?.password || null,
            RoleId: accountInformationData?.roleId?.value || accountInformationData?.roleId,
        }
        createAccount( request )
    };

    const handleClear = () => {
        setFormData( {
            ...CreateAccountManagementData,
            initialState: {
                firstname: "",
                lastName: "",
                email: "",
                password: "",
                roleId: null,
            }
        } );
    };


    return (
        <>
            { allDropDownResponse && <FormCreator
                ref={ createAccountRef }
                { ...formData }
            />
            }
            <div className="col-lg-12 d-flex justify-content-end mt-5">
                <Buttons
                    buttonText="Create"
                    buttonTypeClassName="outline-btn"
                    isLoading={isFetchingAppUpdate}
                    onClick={ handleCreate }
                />
            </div>
        </>
    );
} );

export default CreateAccountManagement;